import { Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import type { EventsCoreDataFragment } from "~/__generated__/graphql";
import { getSdk } from "~/__generated__/graphql";
import client from "~/config/client";
import { MediumBreak, SmallBreak } from "../landing/v2/helpers";
export const geUpcomingEvents = async () => {
  const sdk = getSdk(client);

  const events = await sdk.Events({
    sort: ["publishedAt:desc"],
    filters: { eventDate: { gte: new Date() } },
  });

  return events.events?.data[0];
};
const UpcomingEvent = () => {
  const [upcomingEvent, setUpcomingEvent] = useState<EventsCoreDataFragment | undefined>();

  useEffect(() => {
    geUpcomingEvents().then((events) => {
      setUpcomingEvent(events);
    });
  }, []);
  if (!upcomingEvent) return null;
  return (
    <Box width="full" bgColor={"white"}>
      <Flex
        direction={{ lg: "column", base: "column" }}
        py={{ xl: "100px", lg: "80px", base: "64px" }}
        w="full"
        px={{ xl: "160px", lg: "24px", base: "16px" }}
        maxWidth={"1440px"}
        mx="auto"
      >
        <Flex direction="column" align={"start"} mb={{ lg: "64px", base: "40px" }}>
          <Text
            fontSize={{ lg: "18px", base: "14px" }}
            color="rgba(13, 48, 80, 0.8)"
            lineHeight={{ lg: "18px", base: "14px" }}
            mb={{ lg: "16px", base: "12px" }}
          >
            UPCOMING EVENTS
          </Text>
          <Text
            fontSize={{ lg: "56px", base: "32px" }}
            color="#0D3050"
            lineHeight={{ lg: "64px", base: "36px" }}
            fontFamily={"Georgia"}
            mb={{ lg: "24px", base: "16px" }}
          >
            Experience Our Events
          </Text>
          <Text
            fontSize={{ lg: "24px", base: "16px" }}
            color="rgba(13, 48, 80, 0.8)"
            lineHeight={{ lg: "32px", base: "24px" }}
          >
            We help individuals and teams achieve <SmallBreak /> their full potential{" "}
            <MediumBreak /> through our events.
          </Text>
        </Flex>
        <Flex
          direction={{ lg: "row", base: "column" }}
          gap={{ xl: "40px", lg: "32px", base: "24px" }}
          align={"center"}
        >
          <Image
            src={upcomingEvent.attributes?.thumbnail?.data?.attributes?.url}
            alt=""
            maxWidth={{ lg: "603px" }}
            height={{ xl: "313px", lg: "268px", base: "193px" }}
          />
          <Flex direction="column" align={"start"} justify={"center"} w="full">
            <Text
              fontSize={{ lg: "32px", base: "24px" }}
              color="#0D3050"
              lineHeight={{ lg: "44px", base: "32px" }}
              mb={{ lg: "8px", base: "12px" }}
              fontWeight={600}
              noOfLines={3}
              dangerouslySetInnerHTML={{ __html: upcomingEvent.attributes?.title ?? "" }}
            />

            <Text
              fontSize={{ lg: "18px", base: "16px" }}
              color="rgba(13, 48, 80, 0.8)"
              lineHeight={{ lg: "28px", base: "24px" }}
              mb={{ lg: "24px", base: "20px" }}
              dangerouslySetInnerHTML={{ __html: upcomingEvent.attributes?.description ?? "" }}
            />

            <Flex justify={"start"} width={{ lg: "194px", base: "full" }}>
              <Button
                onClick={() =>
                  window.open(upcomingEvent.attributes?.registerURL as string, "_blank")
                }
                w={{ lg: "121px", base: "full" }}
                color="#0D3050"
              >
                Register
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default UpcomingEvent;
